import type { HydrationOptions } from 'react-dom/client';
import ddt from '@wix/da-ddt';

function toError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error));
}

function reportError(
  error: unknown,
  appName: string,
  message: string,
  tag: string,
  extra: { componentStack?: string }
): void {
  if (Math.floor(Math.random() * 100) === 0) {
    const err = toError(error);
    ddt.alertOnError(err, appName, message, [appName, tag, 'react'], extra);
  }
}

/**
 * Returns React 19 root options (onRecoverableError, onUncaughtError, onCaughtError)
 * that log to DDT via alertOnError. Use as the third argument to hydrateRoot
 * or as the second argument to createRoot.
 *
 * @param appName - Identifier for the app (e.g. 'browse', 'damz') used in alerts and tags.
 */
export function getRootErrorCallbacks(appName: string): HydrationOptions {
  return {
    onRecoverableError(error: unknown, { componentStack }) {
      reportError(error, appName, 'Hydration recoverable error', 'hydration', {
        componentStack: componentStack ?? undefined,
      });
    },
    onUncaughtError(error: unknown, { componentStack }) {
      reportError(error, appName, 'Uncaught error', 'uncaught', {
        componentStack: componentStack ?? undefined,
      });
    },
  };
}
